import BaseModelAPI from '../BaseModelAPI';

export default class Reminder extends BaseModelAPI {
	static entity = 'reminder';
	static entityName = 'reminder';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.incomingDocumentId = '';
			this.incomingDocument = {};
			this.reminderDate = '';
			this.reminderStatusId = '';
			this.reminderStatus = {};
			this.createdBy = '';
			this.updatedBy = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}